import script from "./ShareBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareBtn.vue?vue&type=script&setup=true&lang=js"

import "./ShareBtn.vue?vue&type=style&index=0&id=184ae130&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184ae130"]])

export default __exports__